import { UserManager, WebStorageStateStore } from 'oidc-client';
import store from '@/store/index.js';
import Cookies from 'js-cookie';

const settings = {
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  authority: process.env.VUE_APP_STS_DOMAIN,
  scope: process.env.VUE_APP_SCOPE,
  client_id: process.env.VUE_APP_CLIENT_ID,
  redirect_uri: process.env.VUE_APP_REDIRECT_URI,
  automaticSilentRenew: true,
  validateSubOnSilentRenew: true,
  silent_redirect_uri: process.env.VUE_APP_SILENT_REDIRECT_URI,
  silentRequestTimeout: 10000,
  post_logout_redirect_uri: process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI,
  response_type: 'code',
  popupWindowFeatures:
    'location=no,toolbar=no,width=450,height=650,left=250,top=100',
  filterProtocolClaims: false,
  loadUserInfo: true
};

export function useUserStore() {
  return new AuthService();
}

export default class AuthService {
  async getManager() {
    let manager = store.state.userManager;
    if (!manager) {
      manager = new UserManager(settings);
      store.state.userManager = manager;
    }

    return manager;
  }

  async getUser() {
    const manager = await this.getManager();
    return await manager.getUser();
  }

  async login() {
    Cookies.set(
      'returnUrl',
      window.location.href.substring(window.location.href.indexOf('#') + 1)
    );

    const manager = await this.getManager();
    return await manager.signinRedirect();
  }

  async loginPopup() {
    const manager = await this.getManager();
    return await manager.signinPopup();
  }

  async logout() {
    const manager = await this.getManager();
    return await manager.signoutRedirect();
  }

  async logoutPopup() {
    const manager = await this.getManager();
    return await manager.signoutPopupCallback();
  }

  async getAccessToken() {
    const manager = await this.getManager();
    const user = await manager.getUser();
    return user?.access_token;
  }

  async signinRedirectCallback() {
    try {
      const manager = await this.getManager();
      var user = await manager.signinRedirectCallback();
      if (user) {
        user.returnUrl = Cookies.get('returnUrl');
        Cookies.remove('returnUrl');
        return user;
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  async signinPopupCallback() {
    try {
      const manager = await this.getManager();
      return await manager.signinPopupCallback();
    } catch (error) {
      return null;
    }
  }

  async signinSilentCallback() {
    try {
      const manager = await this.getManager();
      return await manager.signinSilentCallback();
    } catch (error) {
      return null;
    }
  }
}
